// Tabs: [role=tab] buttons reveal every [data-tab-panel] with the matching index (copy panel and photo).
class STabs extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.select(index), { signal });
      tab.addEventListener('keydown', (event) => {
        const rtl = document.documentElement.dir === 'rtl';
        const next = rtl ? 'ArrowLeft' : 'ArrowRight';
        const prev = rtl ? 'ArrowRight' : 'ArrowLeft';
        let target = null;
        if (event.key === next || event.key === 'ArrowDown') target = (index + 1) % this.tabs.length;
        if (event.key === prev || event.key === 'ArrowUp') target = (index - 1 + this.tabs.length) % this.tabs.length;
        if (target === null) return;
        event.preventDefault();
        this.select(target);
        this.tabs[target].focus();
      }, { signal });
    });
  }

  select(index) {
    this.tabs.forEach((tab, i) => {
      tab.setAttribute('aria-selected', String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
    });
    this.querySelectorAll('[data-tab-panel]').forEach((panel) => {
      panel.hidden = Number(panel.dataset.tabPanel) !== index;
    });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('s-tabs')) customElements.define('s-tabs', STabs);
